import { render, staticRenderFns } from "./quick-order-form.vue?vue&type=template&id=271da21f&"
import script from "./quick-order-form.vue?vue&type=script&lang=js&"
export * from "./quick-order-form.vue?vue&type=script&lang=js&"
import style0 from "./quick-order-form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports